import URI from 'jsuri';

/*
 * Pulls in generic assignment-level information:
 * [Instructions, grading metadata, review schema, submission schema, comment schema]
 */
import Q from 'q';

import API from 'js/lib/api';

import type { SubmissionSchemaLinked } from 'bundles/assess-common/types/NaptimeSubmissionSchema';
import type { GradingMetadata, Instructions } from 'bundles/peer/types/NaptimeAssignment';
import type { ReviewSchemaLinked } from 'bundles/peer/types/NaptimeReviewSchema';

const onDemandPeerAssignmentInstructionsApi = API('/api/onDemandPeerAssignmentInstructions.v1', { type: 'rest' });

export type PeerAssignmentApiResponse = {
  elements: [Instructions];
  paging: {};
  linked: {
    'onDemandPeerAssignmentGradingMetadata.v1': [GradingMetadata];
    'onDemandPeerReviewSchemas.v1': [ReviewSchemaLinked | null];
    'onDemandPeerSubmissionSchemas.v1': [SubmissionSchemaLinked];
  };
};

const assignmentInstructionsFields = ['instructions'];

const gradingMetadataFields = ['requiredAuthoredReviewCount', 'isMentorGraded', 'assignmentDetails'];

export const getAssignment = ({
  userId,
  courseId,
  itemId,
}: {
  userId: number;
  courseId: string;
  itemId: string;
}): Q.Promise<PeerAssignmentApiResponse> => {
  const uri = new URI()
    .addQueryParam('q', 'latest')
    .addQueryParam('userId', userId.toString())
    .addQueryParam('courseId', courseId)
    .addQueryParam('itemId', itemId)
    .addQueryParam('includes', ['gradingMetadata', 'reviewSchemas', 'submissionSchemas'].join(','))
    .addQueryParam(
      'fields',
      [
        assignmentInstructionsFields,
        `onDemandPeerAssignmentGradingMetadata.v1(${gradingMetadataFields.join(',')})`,
        'onDemandPeerReviewSchemas.v1(reviewSchema)',
        'onDemandPeerSubmissionSchemas.v1(submissionSchema)',
      ].join(',')
    );

  return Q(onDemandPeerAssignmentInstructionsApi.get(uri.toString()));
};
